module.exports = __webpack_public_path__ + "static/assets/49eee63834262a81888bf0a62a803265.png";